<template>
  <div class="economic-content">
    <div class="central-yunnan-main2">
      <div class="keynote-content">
        <div
          class="keynote-content-item"
          v-for="(item, index) in landListData"
          :key="index"
        >
          <el-carousel
            v-if="index % 2 !== 0"
            height="189px"
            style="width: calc(100% / 3 - 10px)"
            class="keynote-content-img"
          >
            <el-carousel-item v-for="(item, index) in item.imgUrl" :key="index">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="imgUrl + item.filePath"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
          <div class="keynote-content-main">
            <div :class="index % 2 !== 0 ? 'keynote-arrangement' : ''">
              <div
                :class="
                  index % 2 === 0
                    ? 'keynote-content-main-title'
                    : 'keynote-content-main-title2'
                "
              >
                {{ item.countyName }}
              </div>
            </div>
            <div
              class="keynote-main"
              @click="
                title = item.countyName;
                content = item.synopsis;
                dialogVisible = true;
              "
            >
              {{ item.synopsis }}
            </div>
          </div>
          <el-carousel
            v-if="index % 2 === 0"
            height="189px"
            style="width: calc(100% / 3 - 10px)"
            class="keynote-content-img"
          >
            <el-carousel-item v-for="(item, index) in item.imgUrl" :key="index">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="imgUrl + item.filePath"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <div
        style="max-height: 600px; overflow: auto; letter-spacing: 4px"
        class="scrollbar-definition"
      >
        {{ content }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "economic",
  props: ["landList"],
  data() {
    return {
      landListData: [],
      dialogVisible: false,
      title: "",
      content: "",
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  // 行政区划数据啦!
  watch: {
    landList: {
      handler(newVal) {
        if (!!newVal) {
          this.landListData = newVal;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // console.log(this.landList);
  },
  methods: {
    setImgUrl(imgUrl) {
      if (!!imgUrl) {
        return imgUrl[0].url;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.economic-content {
  width: 100%;
  margin: auto;
  background: #f6f6f6;
  padding: 30px 0;
}
.central-yunnan-main2 {
  background: #f6f6f6;
  margin-top: 30px;
}
.central-yunnan-main2:nth-child(1) {
  margin-top: 0;
}
.keynote-content {
  width: 60%;
  margin: 0 auto;
  /*height: 190px;*/
}
.keynote-content-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background: #ffffff;
  margin-top: 20px;
}
.keynote-content-item:nth-child(1) {
  margin-top: 0;
}
.keynote-content-main {
  height: 100%;
  width: calc(100% - (100% / 3 - 10px));
  position: relative;

  /*margin-right: 20px;*/
}
.keynote-content-img {
  width: calc(100% / 3 - 10px);
  height: 189px;
  /*background: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  /*background-image: url("~@/assets/promotion/keynote.png");*/
  background-size: 100% 100%;
  width: 100%;
}
.keynote-content-main-title {
  width: 300px;
  padding: 10px;
  overflow: hidden;
  position: relative; /* 关键：相对定位 */
  background: #0068b7;
  color: #ffffff;
  margin-left: 0;
}
.keynote-content-main-title::after {
  display: inline-block;
  content: "";
  width: 100px;
  height: 60px;
  border-left: 1px #666 solid; /* 关键：左边框，颜色跟 box 投影一样 */
  background: #ffffff; /* 改成 box 一样的背景色即可 */
  transform: rotate(45deg); /* 关键：绝对定位 */
  position: absolute; /* 关键：绝对定位 */
  right: -60px;
  top: -20px;
  z-index: 2; /* 防止折角被覆盖 */
}
.keynote-main {
  margin: 0;
  min-height: 134px;
  padding: 14px 20px 0 20px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  cursor: pointer;
  word-break: break-all;
  word-wrap: break-word;
}
.keynote-content-main::after {
  position: absolute;
  content: "";
  height: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
}
.keynote-content-main-title2 {
  width: 300px;
  padding: 10px;
  overflow: hidden;
  position: relative; /* 关键：相对定位 */
  background: #ea68a2;
  color: #ffffff;
  text-align: right;
  left: 0;
}
.keynote-content-main-title2::after {
  display: inline-block;
  content: "";
  width: 100px;
  height: 60px;
  border-left: 1px #666 solid; /* 关键：左边框，颜色跟 box 投影一样 */
  background: #ffffff; /* 改成 box 一样的背景色即可 */
  transform: rotate(-45deg); /* 关键：绝对定位 */
  position: absolute; /* 关键：绝对定位 */
  left: -50px;
  top: -30px;
  z-index: 2; /* 防止折角被覆盖 */
}
.keynote-arrangement {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.keynote-content-main-title3 {
  background: #32b16c;
}
.keynote-content-img1 {
  margin-left: 0;
  background-image: url("~@/assets/promotion/discuss.png");
  background-size: 100% 100%;
}
.keynote-content-img2 {
  background-image: url("~@/assets/promotion/resources.png");
  background-size: 100% 100%;
}
.keynote-main {
  padding: 14px 20px 0 20px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
::v-deep .el-dialog__body {
  padding: 10px 20px 30px;
}
</style>
